import { LayoutDashboard, ArrowLeftRight, DollarSign, Users, FileBarChart, ClipboardCheck, LineChart, Building2, BarChart3, UserCog, ShieldAlert, ShieldCheck, Landmark, Route as RouteIcon, Scale, ReceiptText, CalendarDays, Coins, Banknote, DatabaseBackup, Trash2, History, Settings, Wallet, HandCoins, BookText } from "lucide-react";

export const NAV_GROUPS = [
  { title: "Kerja Harian", items: [
    { to: "/admin/dashboard", label: "Beranda", hint: "Ringkasan hari ini", icon: LayoutDashboard, tid: "nav-dashboard" },
    { to: "/admin/transaksi", label: "Transaksi Jual / Beli", hint: "Layani nasabah & cetak struk", icon: ArrowLeftRight, tid: "nav-transaksi" },
    { to: "/admin/shift", label: "Shift & Tutup Buku", hint: "Buka/tutup shift, tutup buku, lanjut besok", icon: ClipboardCheck, tid: "nav-shift" },
  ]},
  { title: "Uang & Saldo", items: [
    { to: "/admin/saldo-rupiah", label: "Saldo Rupiah", hint: "Uang tunai di brankas & catatannya", icon: Wallet, tid: "nav-saldo-rupiah" },
    { to: "/admin/stok-valas", label: "Stok Valas", hint: "Mata uang asing, stok cabang, permintaan", icon: Coins, tid: "nav-stok-valas" },
    { to: "/admin/saldo-uang-lebih", label: "Saldo Uang Lebih", hint: "Uang titipan/lebih, terpisah dari kas perusahaan", icon: Banknote, tid: "nav-saldo-uang-lebih" },
    { to: "/admin/piutang", label: "Piutang", hint: "Catat & kelola piutang", icon: HandCoins, tid: "nav-piutang" },
    { to: "/admin/rekening-bank", label: "Saldo Bank", hint: "Rekening perusahaan & catatannya", icon: Landmark, tid: "nav-bank", adminOnly: true, hqOnly: true },
  ]},
  { title: "Harga Kurs", items: [
    { to: "/admin/rates", label: "Atur Harga Kurs", hint: "Harga jual & beli hari ini", icon: DollarSign, tid: "nav-rates", adminOnly: true },
    { to: "/admin/riwayat-kurs", label: "Riwayat Kurs", hint: "Grafik perubahan harga", icon: LineChart, tid: "nav-riwayat-kurs" },
  ]},
  { title: "Nasabah", items: [
    { to: "/admin/nasabah", label: "Data Nasabah", hint: "Identitas & riwayat nasabah", icon: Users, tid: "nav-nasabah" },
    { to: "/admin/kepatuhan", label: "APU-PPT", hint: "Deteksi duplikat & screening watchlist", icon: ShieldCheck, tid: "nav-kepatuhan", adminOnly: true },
  ]},
  { title: "Laporan", items: [
    { to: "/admin/laporan", label: "Laporan Transaksi", hint: "Semua jual-beli & pengeluaran lain", icon: FileBarChart, tid: "nav-laporan" },
    { to: "/admin/ringkasan-bulanan", label: "Ringkasan Bulanan", hint: "Untung, pengeluaran & sisa uang", icon: CalendarDays, tid: "nav-ringkasan-bulanan", superAdminOnly: true },
    { to: "/admin/laporan-keuangan", label: "Kondisi Bisnis (Laba / Rugi)", hint: "Untung-rugi, harta & kewajiban", icon: Scale, tid: "nav-lapkeu", superAdminOnly: true },
    { to: "/admin/coa", label: "Bagan Akun (COA)", hint: "Daftar akun akuntansi lengkap — edit khusus super admin", icon: BookText, tid: "nav-coa", superAdminOnly: true },
    { to: "/admin/konsolidasi", label: "Gabungan Semua Cabang", hint: "Perbandingan antar cabang", icon: BarChart3, tid: "nav-konsolidasi", superAdminOnly: true },
  ]},
  { title: "Pengaturan Lanjutan", collapsible: true, adminOnly: true, items: [
    { to: "/admin/cabang", label: "Cabang", icon: Building2, tid: "nav-cabang", superAdminOnly: true },
    { to: "/admin/users", label: "User Access", icon: UserCog, tid: "nav-users", superAdminOnly: true },
    { to: "/admin/hak-akses", label: "Hak Akses Peran", icon: ShieldCheck, tid: "nav-hak-akses", superAdminOnly: true },
    { to: "/admin/audit", label: "Audit Log", icon: ShieldAlert, tid: "nav-audit", adminOnly: true },
    { to: "/admin/branch-moves", label: "Log Pindah Cabang", icon: RouteIcon, tid: "nav-branch-moves" },
    { to: "/admin/pengaturan-struk", label: "Pengaturan Struk", icon: ReceiptText, tid: "nav-struk-settings", adminOnly: true },
    { to: "/admin/settings", label: "Pengaturan Umum", icon: Settings, tid: "nav-settings", superAdminOnly: true },
    { to: "/admin/urutan-menu", label: "Urutan Menu", icon: ArrowLeftRight, tid: "nav-menu-order", superAdminOnly: true },
    { to: "/admin/backup", label: "Backup Data", icon: DatabaseBackup, tid: "nav-backup", superAdminOnly: true },
    { to: "/admin/reset-data", label: "Reset / Hapus Data", icon: Trash2, tid: "nav-reset-data", superAdminOnly: true },
    { to: "/admin/log-hapus", label: "Log Hapus Data", icon: History, tid: "nav-log-hapus", superAdminOnly: true },
  ]},
];

// Apply a saved order config to the default NAV_GROUPS. Unknown/new groups &
// items fall back to their default position (appended), so new menu additions
// never disappear.
export function applyNavOrder(groups, cfg) {
  if (!cfg || !Array.isArray(cfg.groups) || cfg.groups.length === 0) return groups;
  const byTitle = {};
  groups.forEach((g) => { byTitle[g.title] = g; });
  const ordered = [];
  cfg.groups.forEach((t) => { if (byTitle[t]) { ordered.push(byTitle[t]); delete byTitle[t]; } });
  groups.forEach((g) => { if (byTitle[g.title]) ordered.push(byTitle[g.title]); });
  return ordered.map((g) => {
    const saved = (cfg.items && cfg.items[g.title]) || [];
    const byTo = {};
    g.items.forEach((it) => { byTo[it.to] = it; });
    const items = [];
    saved.forEach((to) => { if (byTo[to]) { items.push(byTo[to]); delete byTo[to]; } });
    g.items.forEach((it) => { if (byTo[it.to]) items.push(byTo[it.to]); });
    return { ...g, items };
  });
}


// Path menu yang SELALU boleh diakses semua user (tak bisa dicabut).
export const ALWAYS_ALLOWED = ["/admin/dashboard"];

// Daftar rata semua item menu (untuk picker akses & pengecekan route).
export const ALL_NAV_ITEMS = NAV_GROUPS.flatMap((g) =>
  g.items.map((it) => ({ ...it, group: g.title }))
);

// Apakah user boleh mengakses path menu tertentu.
// - super_admin: selalu boleh
// - allowed_menus null/undefined: akses penuh sesuai peran (perilaku default)
// - allowed_menus berupa array: hanya path di dalamnya (+ ALWAYS_ALLOWED)
export function isMenuAllowed(user, to) {
  if (!user) return false;
  if (user.role === "super_admin") return true;
  const am = user.allowed_menus;
  if (am == null) return true;
  if (ALWAYS_ALLOWED.includes(to)) return true;
  return Array.isArray(am) && am.includes(to);
}
